/** Shown on phones and small tablets, where the side-by-side editor doesn't fit */
export const MobileNotice = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
    <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
      <div className="mb-6">
        <svg className="mx-auto h-16 w-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Text to Table</h1>
        <h2 className="text-lg font-medium text-gray-700">Oops! We need a bigger screen</h2>
      </div>

      <div className="text-gray-600 space-y-4">
        <p>
          Hey there! 👋 Text to Table works best on a desktop or laptop where you have plenty of room to edit and
          preview your menu side-by-side.
        </p>
        <p>
          Just hop on a desktop or laptop when you're ready, and we'll help you turn your menu into beautiful,
          web-ready HTML!
        </p>
      </div>

      <div className="mt-8 pt-6 border-t border-gray-200">
        <p className="text-sm text-gray-500">
          Created by{' '}
          <a
            href="https://www.studioqdesigns.ca"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-primary underline"
          >
            Studio Q Designs Inc.
          </a>
        </p>
      </div>
    </div>
  </div>
)
